import { Box } from "@mui/material";
import React, { Fragment, useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";


const Camera = ({ onCapture }: { onCapture: (file: File) => void }) => {
  const webcamRef = useRef<Webcam>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [location, setLocation] = useState({ latitude: "", longitude: "" });
  const [facingMode, setFacingMode] = useState<"user" | "environment">("environment");
  
  const videoConstraints = {
    width: 540,
    height: 400,
    facingMode: facingMode,
  };
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLocation({
          latitude: pos.coords.latitude.toFixed(6),
          longitude: pos.coords.longitude.toFixed(6),
        });
      },
      (err) => console.warn("Erro ao obter localização:", err)
    );
  }, []);

  useEffect(() => {
    let animationFrameId: number;

    const render = () => {
      const canvas = canvasRef.current;
      const ctx = canvas?.getContext("2d");
      const video = webcamRef.current?.video as HTMLVideoElement;

      if (canvas && ctx && video && video.readyState === 4) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        const now = new Date();
        const dateStr = now.toLocaleDateString("pt-BR");
        const timeStr = now.toLocaleTimeString("pt-BR");
        const locationStr = `Lat: ${location.latitude}, Lng: ${location.longitude}`;

        ctx.font = "20px Arial";
        ctx.fillStyle = "white";
        ctx.strokeStyle = "black";
        ctx.lineWidth = 2;

        ctx.strokeText(`${dateStr} ${timeStr}`, 10, canvas.height - 60);
        ctx.fillText(`${dateStr} ${timeStr}`, 10, canvas.height - 60);
        ctx.strokeText(locationStr, 10, canvas.height - 30);
        ctx.fillText(locationStr, 10, canvas.height - 30);
      }

      animationFrameId = requestAnimationFrame(render);
    };

    animationFrameId = requestAnimationFrame(render);
    return () => cancelAnimationFrame(animationFrameId);
  }, [location]);

  const capturePhoto = () => {
    const canvas = canvasRef.current;
    if (canvas) {
      canvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], `foto-${Date.now()}.jpeg`, { type: "image/jpeg" });
          onCapture(file);
        }
      }, "image/jpeg");
    }
  };

  const toggleCamera = () => {
    setFacingMode((prev) => (prev === "environment" ? "user" : "environment"));
  };

  return (
    <div style={{ position: "relative", height: "500px", width: "100%", display:"flex", flexDirection:"column", justifyContent: "space-between" }}>
      <div>

      <Webcam
        ref={webcamRef}
        audio={false}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 1,
          width: "100%",
          maxHeight: "400px",
        }}
        onUserMediaError={(err) => alert("Permissão de câmera negada!")}
        />
      <canvas
        ref={canvasRef}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 2,
          width: "100%",
          maxHeight: "400px",
        }}
      />
        </div>
      <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", height: "50px"}}>
      <button
        onClick={capturePhoto}
        style={{
          bottom: 10,
          zIndex: 3,
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        >
        Capturar
      </button>
      <button
        onClick={toggleCamera}
        style={{
          zIndex: 3,
          padding: "10px 20px",
          backgroundColor: "#28a745",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        >
        Trocar câmera
      </button>
        </Box>
    </div>
  );
};

export default Camera;
